import { Point } from '../../../shared/types/mathTypes.ts';
import { Position } from '../../../shared/types/protocol.ts';
import { OptionalExcept } from '../../../shared/types/utilTypes.ts';
import { ContextMenu, MenuItem } from '../../components/contextMenu.tsx';


interface Props {
    page: number;
    screenCoords: Point;
    pdfCoords: Point;
    pdfCoords2?: Point;
    activePosition: Position | null | undefined;
    onAddPosition?: (position: OptionalExcept<Position, 'type'>, page: number, pdfCoords: Point, pdfCoords2?: Point) => void;
    onUpdateLocation?: (page: number, pdfCoords: Point, pdfCoords2?: Point) => void;
    onAddMarker?: (pdfCoords: Point, pdfCoords2?: Point) => void;
    onClose: () => void;
}

export function PdfContextMenu({
    page,
    screenCoords,
    pdfCoords,
    pdfCoords2,
    activePosition,
    onAddPosition,
    onUpdateLocation,
    onAddMarker,
    onClose,
}: Props) {

    const isGeneralInspection = activePosition != null && activePosition.type !== 'generalInspection';
    const menuItems: MenuItem[] = [
        {
            text: 'Add position',
            callback: () => onAddPosition?.({ type: 'measurement' }, page, pdfCoords, pdfCoords2),
        },
        {
            text: 'Add visual inspection',
            callback: () => onAddPosition?.({ type: 'visualInspection' }, page, pdfCoords, pdfCoords2),
        },
        {
            text: 'Update current position',
            isEnabled: activePosition != null && !!onUpdateLocation && isGeneralInspection,
            callback: () => onUpdateLocation && onUpdateLocation(page, pdfCoords, pdfCoords2),
        },
        {
            text: 'Add marker to position',
            isEnabled: activePosition != null && page === activePosition?.page && !!onAddMarker && isGeneralInspection,
            callback: () => onAddMarker && onAddMarker(pdfCoords, pdfCoords2),
        },
        {
            text: 'Copy position',
            isEnabled: activePosition != null && page === activePosition?.page && !!onAddPosition && isGeneralInspection,
            callback: () => activePosition && onAddPosition?.(activePosition, page, pdfCoords, pdfCoords2),
        },
    ];

    return (
        <ContextMenu
            isOpen={true}
            position={screenCoords}
            items={menuItems}
            close={onClose}
        />
    );
}
